<template>
  <v-container fluid>
    <page-header>
      <v-breadcrumbs>
        <v-breadcrumbs-item to="/secure/teachers">Teachers</v-breadcrumbs-item>
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item :to="`/secure/teacher/${teacher.id}`">
          {{ teacher ? `${teacher.firstName} ${teacher.lastName}` : "N/A" }}
        </v-breadcrumbs-item>
        <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
        <v-breadcrumbs-item :disabled="true">
            Edit Info
        </v-breadcrumbs-item>
      </v-breadcrumbs>
    </page-header>

      <v-card width="100%" class="mx-auto">
        <v-card-title>Edit Teacher</v-card-title>
        <v-card-text>
          <v-form ref="teacherForm">
            <v-select
              :items="centers"
              v-model="teacher.center.id"
              label="Location"
              item-text="name"
              item-value="id"
              :rules="[rules.required]"
            />
            <v-text-field
              label="First Name"
              v-model="teacher.firstName"
              :rules="[rules.required]"
            />
            <v-text-field
              label="Last Name"
              v-model="teacher.lastName"
              :rules="[rules.required]"
            />
            <v-text-field
              label="Email"
              v-model="teacher.email"
              :rules="[rules.required, rules.emailMatch]"
            />
            <v-text-field
              label="Phone"
              v-mask="'+1(###) ###-####'"
              v-model="teacher.phone"
              :rules="[rules.phoneMatch]"
            />
            <v-textarea
              :auto-grow="true"
              rows="1"
              label="About"
              v-model="teacher.about"
            />
          </v-form>
          <div v-if="teacher.registered">Is Registered</div>
        </v-card-text>

        <v-card-actions>
          <v-btn color="primary" class="ml-5" @click="updateTeacher">Update</v-btn>
        </v-card-actions>
      </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { mask } from "vue-the-mask";
import {rules} from "@/store/util/rules.js";
const PageHeader = () => import("@/components/common/PageHeader.vue");
import randomColor from "randomcolor";


export default {
  data() {
    return {
      centers: [],
      teacher: {},
      rules
    };
  },
  mounted(){
    this.initTeacher();
    this.loadCenters();
  },
  directives: { mask },
  computed: {
    ...mapGetters(["navState", "isAppLoading"]),
  },
  components:{
    PageHeader
  },
  methods: {
    ...mapActions(["hideDialog", "addErrorMessage"]),
    initTeacher() {
      const teacherId = this.$route.params.id;

      if (teacherId) {
        this.$axios
          .get("teacher/getById", { params: { teacherId: teacherId } })
          .then((resp) => {
            this.teacher = resp.data.data;
            if(!this.teacher.center){
              this.teacher.center = {id: null, name: 'N/A'}
            }
          });
      }
    },
    updateTeacher() {
      if (!this.$refs.teacherForm.validate()) return;
      if(this.teacher.phone){
        //strip all non-numeric from phone number
        const phoneNumber = String(this.teacher.phone).replace(/\D/g,'');
        if(phoneNumber.length < 10 || phoneNumber.length > 11){
          this.addErrorMessage("Invalid phone number");
          return;
        }
        this.teacher.phone = phoneNumber;
      }

      console.log("update teacher");
      const data = {
        id: this.teacher.id,
        firstName: this.teacher.firstName,
        lastName: this.teacher.lastName,
        email: this.teacher.email,
        phone: this.teacher.phone,
        about: this.teacher.about,
        centerId: this.teacher.center.id,
        color: this.teacher.color ? this.teacher.color:randomColor.randomColor()
      };
      this.$axios
        .post("/teacher/update", data)
        .then((resp) => {
          console.log(resp.data.data);
          const updatedTeacher = resp.data.data;
          this.$router.push({name: 'Teacher', params: {id: updatedTeacher.id}})
        })
        .catch((error) => {
          this.addErrorMessage(error.message);
        });
    },
    loadCenters() {
      this.$axios.get("/center/get-my-centers").then((resp) => {
        // console.log(resp.data);
        this.centers = resp.data;
      });
    },
  },
};
</script>

<style>
</style>